module.exports = __webpack_public_path__ + "static/media/has_account.d62af24a.svg";